webpackJsonp([126609682503911],{

/***/ 275:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _roomGreen = __webpack_require__(820);
	
	var _roomGreen2 = _interopRequireDefault(_roomGreen);
	
	var _layoutRoomGreen = __webpack_require__(275);
	
	var _layoutRoomGreen2 = _interopRequireDefault(_layoutRoomGreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_roomGreen2.default, _extends({}, props, _layoutRoomGreen2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(106);
	var isArguments = __webpack_require__(105);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(122);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(104);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(121);
	
	var _HelmetConstants = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(118);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(107);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(125);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/toilet.aa5c2793.m4a";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/xylophone_affirm1.65e3a032.wav";

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/character--keoni-shaka@3x.353e4dc8.png";

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/checked.41aa47c3.png";

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--bath.5a8b38fc.png";

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--bed.79eb97f3.png";

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--city.66a826b0.png";

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--garage.0c84b007.png";

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--kitchen.eda43d38.png";

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--laundry.cf1b4511.png";

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--living.9d6132a9.png";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shaka.34d2e1f2.png";

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tile--overlay.5c5e460a.png";

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'Container'
	})(['align-items:center;background-attachment:fixed;background:linear-gradient(to bottom,#264554,#3ea9b4);color:#fff;display:flex;flex-direction:column;font-family:', ';justify-content:center;min-height:100%;overflow:hidden;padding:', ';padding-bottom:calc(', ' + ', ');position:relative;@media (min-height:650px) and (min-width:', 'px){background:linear-gradient(to right,#76ced9,#0a9ca6);padding:', ' ', ';padding-bottom:calc( ', ' + ', ' );}'], function (p) {
	  return p.theme.fontFamily.primary;
	}, function (p) {
	  return p.theme.spacing(1);
	}, function (p) {
	  return p.theme.spacing(1);
	}, function (p) {
	  return p.theme.spacing(4);
	}, function (p) {
	  return p.theme.mediaSizes.medium;
	}, function (p) {
	  return p.theme.spacing(3);
	}, function (p) {
	  return p.theme.spacing(1);
	}, function (p) {
	  return p.theme.spacing(3);
	}, function (p) {
	  return p.theme.spacing(6);
	});
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: #fff;\n'], ['\n  color: #fff;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: #c9e9ea;\n'], ['\n  color: #c9e9ea;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: #76cdd9;\n  font-size: ', ';\n\n  ', ';\n'], ['\n  color: #76cdd9;\n  font-size: ', ';\n\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: ', ';\n  '], ['\n    font-size: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _styledComponents2.default.p.withConfig({
	  displayName: 'Copy__Base'
	})(['font-family:', ';font-size:', ';margin-bottom:', ';text-align:', ';text-transform:', ';width:100%;margin-top:', ';&:last-child{margin-bottom:0;}a{color:#ffd98f;}'], function (p) {
	  return p.theme.fontFamily.primary;
	}, function (p) {
	  return p.theme.fontSize(p.large ? 2 : 1.5);
	}, function (p) {
	  return p.last ? 0 : p.theme.spacing(1);
	}, function (p) {
	  return p.textAlign;
	}, function (p) {
	  return p.em ? 'uppercase' : 'none';
	}, function (p) {
	  return p.marginTop || undefined;
	});
	
	var Level1 = Base.extend(_templateObject);
	
	var Level2 = Base.extend(_templateObject2);
	
	var Level3 = Base.extend(_templateObject3, function (p) {
	  return p.theme.fontSize(1);
	}, _theme.media.greaterThan('medium')(_templateObject4, function (p) {
	  return p.theme.fontSize(p.large ? 2 : 1.5);
	}));
	
	var comps = [Level1, Level2, Level3];
	
	var Copy = function Copy(_ref) {
	  var children = _ref.children,
	      _ref$level = _ref.level,
	      level = _ref$level === undefined ? 1 : _ref$level,
	      _ref$large = _ref.large,
	      large = _ref$large === undefined ? false : _ref$large,
	      _ref$em = _ref.em,
	      em = _ref$em === undefined ? false : _ref$em,
	      _ref$last = _ref.last,
	      last = _ref$last === undefined ? false : _ref$last,
	      _ref$textAlign = _ref.textAlign,
	      textAlign = _ref$textAlign === undefined ? 'center' : _ref$textAlign,
	      props = _objectWithoutProperties(_ref, ['children', 'level', 'large', 'em', 'last', 'textAlign']);
	
	  var Comp = comps[level - 1];
	
	  return _react2.default.createElement(
	    Comp,
	    _extends({ large: large, em: em, last: last, textAlign: textAlign }, props),
	    children
	  );
	};
	
	exports.default = Copy;
	module.exports = exports['default'];

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MobileTilesGroup = exports.DesktopTileGroup = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      display: ', '; \n  '], ['\n      display: ', '; \n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(9);
	
	var _RoomOptionTile = __webpack_require__(50);
	
	var _RoomOptionTile2 = _interopRequireDefault(_RoomOptionTile);
	
	var _Heading = __webpack_require__(15);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _PlayButton = __webpack_require__(21);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _roomLiving = __webpack_require__(37);
	
	var _roomLiving2 = _interopRequireDefault(_roomLiving);
	
	var _roomBath = __webpack_require__(31);
	
	var _roomBath2 = _interopRequireDefault(_roomBath);
	
	var _roomBed = __webpack_require__(32);
	
	var _roomBed2 = _interopRequireDefault(_roomBed);
	
	var _roomGarage = __webpack_require__(34);
	
	var _roomGarage2 = _interopRequireDefault(_roomGarage);
	
	var _roomKitchen = __webpack_require__(35);
	
	var _roomKitchen2 = _interopRequireDefault(_roomKitchen);
	
	var _roomLaundry = __webpack_require__(36);
	
	var _roomLaundry2 = _interopRequireDefault(_roomLaundry);
	
	var _roomCity = __webpack_require__(33);
	
	var _roomCity2 = _interopRequireDefault(_roomCity);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__Container'
	})(['margin-bottom:4rem;position:relative;height:100%;width:100%;']);
	// Desktop
	var DesktopContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__DesktopContainer'
	})(['height:100%;display:none;', ';padding-bottom:40px;'], _theme.media.greaterThan('medium')(_templateObject));
	
	var DesktopContent = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__DesktopContent'
	})(['align-items:center;display:flex;flex-shrink:0;justify-content:center;margin:0 -', ';padding:10px 0 40px 0;height:12.5rem;'], function (p) {
	  return p.theme.spacing(7);
	});
	
	// Mobile
	var MobileContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__MobileContainer'
	})(['align-items:center;flex-direction:column;justify-content:center;margin:0 -', ';padding-bottom:', ';transform:', ';display:flex;', ';'], function (p) {
	  return p.theme.spacing(6.5);
	}, function (p) {
	  return p.theme.spacing(3.75);
	}, function (p) {
	  return p.context === 'modal' ? 'translateY(3%)' : 'none';
	}, _theme.media.greaterThan('medium')(_templateObject2, function (p) {
	  return p.context === 'modal' ? 'flex' : 'none';
	}));
	
	var MobileRoomName = (0, _styledComponents2.default)(_Heading2.default).withConfig({
	  displayName: 'LevelChooser__MobileRoomName'
	})(['margin-top:', ';'], function (p) {
	  return p.theme.spacing(0);
	});
	
	var TopContent = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__TopContent'
	})(['width:33.33%;display:flex;height:100%;']);
	
	var MiddleContent = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__MiddleContent'
	})(['width:50%;display:flex;margin-bottom:-23px;margin-top:-23px;height:100%;']);
	
	var BottomContent = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__BottomContent'
	})(['width:33.33%;display:flex;height:100%;']);
	
	var DesktopSelectedRoom = _styledComponents2.default.div.withConfig({
	  displayName: 'LevelChooser__DesktopSelectedRoom'
	})(['display:flex;justify-content:center;margin:-20px 0 20px 0;align-items:flex-start;']);
	
	var DesktopTileGroup = exports.DesktopTileGroup = function DesktopTileGroup(_ref) {
	  var gameFinished = _ref.gameFinished,
	      selectedRoom = _ref.selectedRoom;
	
	  return _react2.default.createElement(
	    DesktopContainer,
	    null,
	    _react2.default.createElement(
	      _Heading2.default,
	      { fullWidth: true, large: true, level: 4 },
	      gameFinished ? 'Choose a room to play again' : 'Choose a room'
	    ),
	    _react2.default.createElement(
	      DesktopContent,
	      null,
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomLiving2.default,
	        roomId: 'living-room',
	        url: '/living-room'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomKitchen2.default,
	        roomId: 'kitchen',
	        url: '/kitchen'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomBed2.default,
	        roomId: 'bedroom',
	        url: '/bedroom'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomBath2.default,
	        roomId: 'bathroom',
	        url: '/bathroom'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomLaundry2.default,
	        roomId: 'laundry-room',
	        url: '/laundry-room'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomGarage2.default,
	        roomId: 'garage',
	        url: '/garage'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'desktop',
	        img: _roomCity2.default,
	        roomId: 'city',
	        url: '/city'
	      })
	    ),
	    _react2.default.createElement(
	      DesktopSelectedRoom,
	      null,
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: 3 },
	        selectedRoom ? selectedRoom : ''
	      )
	    )
	  );
	};
	
	var MobileTilesGroup = exports.MobileTilesGroup = function MobileTilesGroup(_ref2) {
	  var context = _ref2.context,
	      gameFinished = _ref2.gameFinished,
	      selectedRoom = _ref2.selectedRoom;
	
	  return _react2.default.createElement(
	    MobileContainer,
	    { context: context },
	    _react2.default.createElement(
	      _Heading2.default,
	      {
	        fullWidth: true,
	        large: true,
	        level: 4,
	        hide: context === 'modal'
	      },
	      gameFinished ? 'Choose a level to play again' : 'Choose a level'
	    ),
	    _react2.default.createElement(
	      TopContent,
	      null,
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomLiving2.default,
	        roomId: 'living-room',
	        url: '/living-room'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomKitchen2.default,
	        roomId: 'kitchen',
	        url: '/kitchen'
	      })
	    ),
	    _react2.default.createElement(
	      MiddleContent,
	      null,
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomBed2.default,
	        roomId: 'bedroom',
	        url: '/bedroom'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomCity2.default,
	        roomId: 'city',
	        url: '/city'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomBath2.default,
	        roomId: 'bathroom',
	        url: '/bathroom'
	      })
	    ),
	    _react2.default.createElement(
	      BottomContent,
	      null,
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomGarage2.default,
	        roomId: 'garage',
	        url: '/garage'
	      }),
	      _react2.default.createElement(_RoomOptionTile2.default, {
	        viewport: 'mobile',
	        img: _roomLaundry2.default,
	        roomId: 'laundry-room',
	        url: '/laundry-room'
	      })
	    ),
	    _react2.default.createElement(
	      MobileRoomName,
	      { level: 3, last: true },
	      selectedRoom ? selectedRoom : 'Select'
	    )
	  );
	};
	
	var LevelChooser = function (_Component) {
	  _inherits(LevelChooser, _Component);
	
	  function LevelChooser(props) {
	    _classCallCheck(this, LevelChooser);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  LevelChooser.prototype.handleClick = function handleClick(e) {
	    var buttonUrl = this.props.startButtonUrl;
	    if (buttonUrl === null) {
	      e.preventDefault();
	      alert('please select level');
	    }
	  };
	
	  LevelChooser.prototype.render = function render() {
	    var _props = this.props,
	        selectedRoom = _props.selectedRoom,
	        isOver18 = _props.isOver18;
	
	    var selectedRoomTrimmed = selectedRoom.split('-').join(' ');
	
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(DesktopTileGroup, {
	        gameFinished: this.props.gameFinished,
	        selectedRoom: selectedRoomTrimmed,
	        isOver18: isOver18
	      }),
	      _react2.default.createElement(MobileTilesGroup, {
	        gameFinished: this.props.gameFinished,
	        selectedRoom: selectedRoomTrimmed,
	        isOver18: isOver18
	      }),
	      _react2.default.createElement(_PlayButton2.default, null)
	    );
	  };
	
	  return LevelChooser;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedRoom: state.gameProgress.selectedRoom,
	    isOver18: state.player.isOver18
	  };
	};
	
	var LevelChooserConnected = (0, _reactRedux.connect)(mapStateToProps, null)(LevelChooser);
	exports.default = LevelChooserConnected;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['    \n    width: ', ';\n '], ['    \n    width: ', ';\n ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _redux = __webpack_require__(10);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(4);
	
	var _gameProgress = __webpack_require__(12);
	
	var _itemInteractions = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledButton = (0, _styledComponents2.default)(_Button2.default).withConfig({
	  displayName: 'PlayButton__StyledButton'
	})(['bottom:0;left:50%;position:absolute;transform:translate(-50%,50%);width:60%;display:flex;', ';'], _theme.media.greaterThan('medium')(_templateObject, function (p) {
	  return p.size === 'large' ? '30%' : '25%';
	}));
	
	var PlayButton = function (_Component) {
	  _inherits(PlayButton, _Component);
	
	  function PlayButton(props) {
	    _classCallCheck(this, PlayButton);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PlayButton.prototype.handleClick = function handleClick(e) {
	    var setModalStatus = this.props.setModalStatus;
	
	    var buttonUrl = this.props.startButtonUrl;
	
	    if (location.pathname === buttonUrl) {
	      this.props.removeItemsForRoom(buttonUrl.slice(1));
	    }
	
	    if (buttonUrl === null) {
	      e.preventDefault();
	      alert('please select level');
	    } else {
	      setModalStatus(false);
	    }
	  };
	
	  PlayButton.prototype.render = function render() {
	    var buttonCopy = this.props.buttonCopy ? this.props.buttonCopy : "Let's go";
	    return _react2.default.createElement(
	      StyledButton,
	      {
	        onClick: this.handleClick,
	        to: this.props.startButtonUrl,
	        size: this.props.size,
	        props: this.props
	      },
	      buttonCopy
	    );
	  };
	
	  return PlayButton;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    startButtonUrl: state.gameProgress.startButtonUrl
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ setModalStatus: _gameProgress.setModalStatus, removeItemsForRoom: _itemInteractions.removeItemsForRoom }, dispatch);
	};
	
	var PlayButtonConnected = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PlayButton);
	
	exports.default = PlayButtonConnected;
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 600px;\n    margin: 0 auto;\n    padding: 50px 0;\n  '], ['\n    width: 600px;\n    margin: 0 auto;\n    padding: 50px 0;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 0 50px;\n    max-height: none;\n    overflow-y: hidden;\n    margin-top: 0;\n  '], ['\n    padding: 0 50px;\n    max-height: none;\n    overflow-y: hidden;\n    margin-top: 0;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    display: none; \n  '], ['\n    display: none; \n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: 2.5rem;\n  '], ['\n    font-size: 2.5rem;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto;\n    gap: 1rem;\n    margin-top: 2rem;\n  '], ['\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto;\n    gap: 1rem;\n    margin-top: 2rem;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    margin-bottom: calc((50px + 28px) * -1);\n    margin-top: 2rem;\n  '], ['\n    margin-bottom: calc((50px + 28px) * -1);\n    margin-top: 2rem;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(9);
	
	var _redux = __webpack_require__(10);
	
	var _gatsbyLink = __webpack_require__(67);
	
	var _reactMotion = __webpack_require__(149);
	
	var _gameProgress = __webpack_require__(12);
	
	var _quizzes = __webpack_require__(41);
	
	var _theme = __webpack_require__(4);
	
	var _Heading = __webpack_require__(15);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Copy = __webpack_require__(28);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _helpers = __webpack_require__(40);
	
	var _characterKeoniTip3x = __webpack_require__(199);
	
	var _characterKeoniTip3x2 = _interopRequireDefault(_characterKeoniTip3x);
	
	var _shaka = __webpack_require__(129);
	
	var _shaka2 = _interopRequireDefault(_shaka);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var QUIZ_STATE = {
	  INITIAL: 'initial',
	  CORRECT: 'correct',
	  INCORRECT: 'incorrect'
	};
	
	var GUESS_STATE = {
	  INITIAL: 'guess-initial',
	  CORRECT: 'guess-correct',
	  INCORRECT: 'guess-incorrect'
	};
	
	var CHOICES = ['a', 'b', 'c', 'd'];
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__Container'
	})(['display:', ';position:fixed;left:0;top:0;bottom:0;right:0;width:100%;height:100%;z-index:11;padding:0 30px;'], function (p) {
	  return p.isOpen ? 'flex' : 'none';
	});
	
	var Content = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__Content'
	})(['background:linear-gradient(0deg,', ');border-radius:', ';font-family:', ';isolation:isolate;width:100%;align-self:center;padding:24px 0;display:flex;flex-direction:column;position:relative;', ';'], _theme.theme.color.Tip.bg.join(','), _theme.theme.spacing(-1), _theme.theme.fontFamily.primary, _theme.media.greaterThan('medium')(_templateObject));
	
	var ScrollContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__ScrollContainer'
	})(['display:flex;flex-direction:column;overflow-y:scroll;max-height:50vh;padding:0 24px;margin-top:1.25rem;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}', ';'], _theme.media.greaterThan('medium')(_templateObject2));
	
	var Overlay = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__Overlay'
	})(['background-color:rgba(0,0,0,0.6);pointer-events:auto;position:absolute;left:0;top:0;bottom:0;right:0;height:100%;width:100%;']);
	
	var Character = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__Character'
	})(['width:100px;align-self:center;margin-top:calc((24px + 50px) * -1);img{height:100%;max-width:100%;object-fit:contain;}', ''], _theme.media.greaterThan('medium')(_templateObject3));
	
	var QuizHeading = (0, _styledComponents2.default)(_Heading2.default).withConfig({
	  displayName: 'QuizModal__QuizHeading'
	})(['margin-bottom:0;font-size:2rem;text-transform:none;color:', ';', ''], function (p) {
	  return [QUIZ_STATE.CORRECT].includes(p.quizState) ? p.theme.color.limeGreen : p.quizState === QUIZ_STATE.INCORRECT ? '#e75c5c' : undefined;
	}, _theme.media.greaterThan('medium')(_templateObject4));
	
	var QuizCopy = (0, _styledComponents2.default)(_Copy2.default).withConfig({
	  displayName: 'QuizModal__QuizCopy'
	})(['margin-top:0.25rem;']);
	
	var MultipleChoice = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__MultipleChoice'
	})(['display:grid;gap:0.75rem;margin-top:1.5rem;', ''], _theme.media.greaterThan('medium')(_templateObject5));
	
	var OptionButton = _styledComponents2.default.button.withConfig({
	  displayName: 'QuizModal__OptionButton'
	})(['display:flex;cursor:pointer;border:0;background:none;padding:0;&:disabled{pointer-events:none;}']);
	
	var Letter = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__Letter'
	})(['isolation:isolate;border-radius:50%;border:0.2rem solid ', ';background:', ';font-family:', ';color:', ';font-size:', ';width:48px;height:48px;display:flex;align-items:center;justify-content:center;flex-shrink:0;align-self:center;&:hover{background:linear-gradient( to bottom,', ' );}'], _theme.theme.color.Button.border, function (p) {
	  return p.guessState === GUESS_STATE.INITIAL ? 'linear-gradient(to bottom, ' + _theme.theme.color.Button.bg.join(',') + ')' : p.guessState === GUESS_STATE.INCORRECT ? // prettier-ignore
	  'linear-gradient(to bottom, ' + _theme.theme.color.Hint.bg.join(',') + ') !important' : // prettier-ignore
	  'linear-gradient(to bottom, ' + _theme.theme.color.Button.bgActive.join(',') + ') !important';
	}, function (p) {
	  return p.theme.fontFamily.primary;
	}, function (p) {
	  return p.theme.color.Button.copy;
	}, function (p) {
	  return p.theme.fontSize(2);
	}, function (props) {
	  return props.theme.color.Button.bgHover ? props.theme.color.Button.bgHover.join(',') : props.theme.color.Button.bg.join(',');
	});
	
	var StyledShaka = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__StyledShaka'
	})(['width:', ';position:', ';right:', ';bottom:', ';img{height:100%;max-width:100%;object-fit:contain;}'], function (p) {
	  return p.width || '68px';
	}, function (p) {
	  return p.position;
	}, function (p) {
	  return p.right;
	}, function (p) {
	  return p.bottom;
	});
	
	var QuizButton = (0, _styledComponents2.default)(_Button2.default).withConfig({
	  displayName: 'QuizModal__QuizButton'
	})(['align-self:center;min-width:160px;margin-bottom:calc((24px + 28px) * -1);margin-top:1.5rem;cursor:pointer;', ''], _theme.media.greaterThan('medium')(_templateObject6));
	
	var TextContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'QuizModal__TextContainer'
	})(['display:flex;align-items:center;width:100%;background-color:#032e39;border-radius:8px;margin-left:-25px;padding:6px 20px 6px 37px;height:100%;']);
	
	var Shaka = function Shaka(props) {
	  return _react2.default.createElement(
	    StyledShaka,
	    props,
	    _react2.default.createElement('img', {
	      src: _shaka2.default,
	      alt: '',
	      loading: 'lazy',
	      decoding: 'async',
	      width: 366,
	      height: 336
	    })
	  );
	};
	
	var OptionCopy = (0, _styledComponents2.default)(_Copy2.default).withConfig({
	  displayName: 'QuizModal__OptionCopy'
	})(['color:', ';opacity:', ';'], function (p) {
	  return p.guessState === GUESS_STATE.CORRECT ? _theme.theme.color.limeGreen : undefined;
	}, function (p) {
	  return p.guessState === GUESS_STATE.INCORRECT ? 0.5 : undefined;
	});
	
	var Option = function Option(_ref) {
	  var label = _ref.label,
	      value = _ref.value,
	      _ref$guessState = _ref.guessState,
	      guessState = _ref$guessState === undefined ? GUESS_STATE.INITIAL : _ref$guessState,
	      quizState = _ref.quizState,
	      props = _objectWithoutProperties(_ref, ['label', 'value', 'guessState', 'quizState']);
	
	  return _react2.default.createElement(
	    OptionButton,
	    _extends({
	      disabled: guessState === GUESS_STATE.INCORRECT || quizState === QUIZ_STATE.CORRECT
	    }, props),
	    _react2.default.createElement(
	      Letter,
	      { guessState: guessState },
	      value.toUpperCase()
	    ),
	    _react2.default.createElement(
	      TextContainer,
	      null,
	      _react2.default.createElement(
	        OptionCopy,
	        { last: true, textAlign: 'left', guessState: guessState },
	        label
	      )
	    )
	  );
	};
	
	var QuizModal = function (_Component) {
	  _inherits(QuizModal, _Component);
	
	  function QuizModal(props) {
	    _classCallCheck(this, QuizModal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleContinue = _this.handleContinue.bind(_this);
	    _this.resetModal = _this.resetModal.bind(_this);
	    _this.shake = _this.shake.bind(_this);
	    _this.finalize = _this.finalize.bind(_this);
	
	    _this.state = QuizModal.initialState;
	    return _this;
	  }
	
	  QuizModal.prototype.resetModal = function resetModal() {
	    this.setState(QuizModal.initialState);
	    this.props.closeQuizModal();
	  };
	
	  QuizModal.prototype.shake = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              this.setState({ x: -35, hasAnsweredIncorrectly: true });
	              _context.next = 3;
	              return (0, _helpers.delay)(75);
	
	            case 3:
	              this.setState({ x: 35 });
	              _context.next = 6;
	              return (0, _helpers.delay)(75);
	
	            case 6:
	              this.setState({ x: 0 });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function shake() {
	      return _ref2.apply(this, arguments);
	    }
	
	    return shake;
	  }();
	
	  QuizModal.prototype.handleClick = function handleClick(guess) {
	    if (this.state.quizState === QUIZ_STATE.CORRECT) return;
	
	    var answer = this.props.answer;
	
	
	    if (!answer.includes(guess)) {
	      this.setState({
	        quizState: QUIZ_STATE.INCORRECT,
	        incorrectGuesses: [].concat(this.state.incorrectGuesses, [guess])
	      });
	      this.shake();
	
	      return;
	    }
	
	    var correctGuesses = [].concat(this.state.correctGuesses, [guess]);
	    var isDone = correctGuesses.length === answer.length;
	
	    this.setState({
	      quizState: isDone ? QUIZ_STATE.CORRECT : QUIZ_STATE.INITIAL,
	      correctGuesses: [].concat(this.state.correctGuesses, [guess])
	    });
	  };
	
	  QuizModal.prototype.finalize = function finalize() {
	    var _props = this.props,
	        setModalStatus = _props.setModalStatus,
	        submitQuizAnswer = _props.submitQuizAnswer,
	        selectedRoomId = _props.selectedRoomId,
	        roomsCleared = _props.roomsCleared,
	        setGameFinished = _props.setGameFinished,
	        setSelectedRoom = _props.setSelectedRoom,
	        setStartButtonUrl = _props.setStartButtonUrl,
	        setRoomsCleared = _props.setRoomsCleared;
	
	
	    var hasClearedRoom = roomsCleared.includes(selectedRoomId);
	    if (!hasClearedRoom) {
	      setRoomsCleared([].concat(roomsCleared, [selectedRoomId]));
	    }
	
	    submitQuizAnswer({ roomId: selectedRoomId });
	    this.resetModal();
	
	    if ((0, _helpers.isLastRoom)(roomsCleared, selectedRoomId)) {
	      setGameFinished(true);
	      setModalStatus(false);
	
	      return (0, _gatsbyLink.navigateTo)('/aloha');
	    }
	
	    (0, _helpers.selectRandomRoom)([].concat(roomsCleared, [selectedRoomId]), setSelectedRoom, setStartButtonUrl);
	    setModalStatus(true);
	  };
	
	  QuizModal.prototype.handleContinue = function handleContinue() {
	    this.finalize();
	  };
	
	  QuizModal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        isActive = _props2.isActive,
	        question = _props2.question,
	        options = _props2.options,
	        roomsCleared = _props2.roomsCleared,
	        selectedRoomId = _props2.selectedRoomId;
	    var _state = this.state,
	        quizState = _state.quizState,
	        incorrectGuesses = _state.incorrectGuesses,
	        correctGuesses = _state.correctGuesses;
	
	
	    return _react2.default.createElement(
	      Container,
	      { isOpen: isActive },
	      _react2.default.createElement(Overlay, null),
	      _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          defaultStyle: { x: 0 },
	          style: { x: (0, _reactMotion.spring)(this.state.x, { stiffness: 300 }) }
	        },
	        function (style) {
	          return _react2.default.createElement(
	            Content,
	            { style: { transform: 'translateX(' + style.x + 'px)' } },
	            _react2.default.createElement(
	              Character,
	              null,
	              _react2.default.createElement('img', { src: _characterKeoniTip3x2.default, width: 303, height: 323 })
	            ),
	            _react2.default.createElement(
	              ScrollContainer,
	              null,
	              _react2.default.createElement(
	                QuizHeading,
	                {
	                  level: 1,
	                  textAlign: 'left',
	                  quizState: quizState,
	                  first: true
	                },
	                quizState === QUIZ_STATE.INITIAL && 'POP QUIZ!',
	                quizState === QUIZ_STATE.CORRECT && "CORRECT! You've earned a shaka!",
	                quizState === QUIZ_STATE.INCORRECT && 'OOPS! Try Again.'
	              ),
	              _react2.default.createElement(
	                QuizCopy,
	                { textAlign: 'left', last: true },
	                question
	              ),
	              _react2.default.createElement(
	                MultipleChoice,
	                null,
	                CHOICES.map(function (option) {
	                  var label = options[option];
	                  if (!label) return null;
	
	                  return _react2.default.createElement(Option, {
	                    key: option,
	                    label: label,
	                    value: option,
	                    guessState: incorrectGuesses.includes(option) ? GUESS_STATE.INCORRECT : correctGuesses.includes(option) ? GUESS_STATE.CORRECT : GUESS_STATE.INITIAL,
	                    quizState: quizState,
	                    onClick: function onClick() {
	                      return _this2.handleClick(option);
	                    }
	                  });
	                })
	              )
	            ),
	            quizState === QUIZ_STATE.CORRECT && _react2.default.createElement(Shaka, { position: 'absolute', right: '15px', bottom: '15px' }),
	            quizState === QUIZ_STATE.CORRECT && _react2.default.createElement(
	              QuizButton,
	              { useButtonTag: true, onClick: _this2.handleContinue },
	              (0, _helpers.getQuizSubmitButtonText)({
	                roomsCleared: roomsCleared,
	                roomId: selectedRoomId
	              })
	            )
	          );
	        }
	      )
	    );
	  };
	
	  return QuizModal;
	}(_react.Component);
	
	QuizModal.initialState = {
	  x: 0,
	  quizState: QUIZ_STATE.INITIAL,
	  incorrectGuesses: [],
	  correctGuesses: [],
	  isSubmitting: false
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isActive: state.quizzes.isActive,
	    question: state.quizzes.question,
	    answer: state.quizzes.answer,
	    options: state.quizzes.options,
	    selectedRoomId: state.gameProgress.selectedRoom,
	    roomsCleared: state.gameProgress.roomsCleared,
	    isOver18: state.player.isOver18,
	    clearedQuizRoomIds: state.quizzes.clearedQuizRoomIds,
	    firstName: state.player.firstName,
	    lastName: state.player.lastName,
	    zipCode: state.player.zipCode,
	    email: state.player.email
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    setModalStatus: _gameProgress.setModalStatus,
	    setGameFinished: _gameProgress.setGameFinished,
	    setRoomsCleared: _gameProgress.setRoomsCleared,
	    setSelectedRoom: _gameProgress.setSelectedRoom,
	    setStartButtonUrl: _gameProgress.setStartButtonUrl,
	    submitQuizAnswer: _quizzes.submitQuizAnswer,
	    closeQuizModal: _quizzes.closeQuizModal
	  }, dispatch);
	};
	
	var QuizModalConnected = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuizModal);
	exports.default = QuizModalConnected;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    height: 100%;\n    position: absolute;\n  '], ['\n    height: 100%;\n    position: absolute;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    height: 380px;\n    left: 50%;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 700px;\n  '], ['\n    height: 380px;\n    left: 50%;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 700px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  flex-direction: row;\n  width: unset;\n  margin-bottom: 0;  \n'], ['\n  flex-direction: row;\n  width: unset;\n  margin-bottom: 0;  \n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: flex;  \n  '], ['\n    display: flex;  \n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    padding-top: 0;\n    width: 46%;\n  '], ['\n    padding-top: 0;\n    width: 46%;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n'], ['\n  position: absolute;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['    \n    display: block;\n  '], ['    \n    display: block;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Item = __webpack_require__(13);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _ItemImage = __webpack_require__(5);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _reactRedux = __webpack_require__(9);
	
	var _theme = __webpack_require__(4);
	
	var _LevelChooser = __webpack_require__(49);
	
	var _Heading = __webpack_require__(15);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _PlayButton = __webpack_require__(21);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _characterKeoniShaka3x = __webpack_require__(59);
	
	var _characterKeoniShaka3x2 = _interopRequireDefault(_characterKeoniShaka3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__Container'
	})(['align-items:center;display:', ';height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%;'], function (p) {
	  return p.isOpen ? 'flex' : 'none';
	});
	var Modal = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__Modal'
	})(['align-items:center;display:flex;flex-direction:column;justify-content:center;left:0;top:0;width:100%;z-index:12;', ';'], _theme.media.greaterThan('medium')(_templateObject));
	var Content = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__Content'
	})(['background:linear-gradient(0deg,', ');border-radius:', ';font-family:', ';padding:', ';position:relative;display:flex;margin:0 50px;width:85%;height:100%;', ';'], _theme.theme.color.Tip.bg.join(','), _theme.theme.spacing(-1), _theme.theme.fontFamily.primary, _theme.theme.spacing(1), _theme.media.greaterThan('medium')(_templateObject2));
	var Flex = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__Flex'
	})(['flex-direction:column;display:flex;margin-bottom:-25px;width:100%;', ';'], _theme.media.greaterThan('medium')(_templateObject3));
	var Copy = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__Copy'
	})(['display:none;flex-direction:column;justify-content:center;align-items:flex-start;width:62%;padding:0 0 0 3rem;', ';'], _theme.media.greaterThan('medium')(_templateObject4));
	
	var MobileCopy = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__MobileCopy'
	})(['display:flex;flex-direction:column;flex-shrink:0;justify-content:center;padding:0 10px;width:100%;', ';'], _theme.media.greaterThan('medium')(_templateObject5));
	
	var TilesWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__TilesWrapper'
	})(['flex-shrink:0;margin:0 auto;width:70%;', ';'], _theme.media.greaterThan('medium')(_templateObject6));
	
	var Tiles = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__Tiles'
	})(['position:relative;', ';'], _theme.media.greaterThan('medium')(_templateObject7));
	
	var TipBackground = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomChooserModal__TipBackground'
	})(['background-color:', ';height:100%;width:100%;left:0;pointer-events:', ';position:absolute;top:0;z-index:11;'], function (p) {
	  return p.block ? 'rgba(0, 0, 0, 0.6)' : 'transparent';
	}, function (p) {
	  return p.block ? 'auto' : 'none';
	});
	
	var StyledItem = (0, _styledComponents2.default)(_Item2.default).withConfig({
	  displayName: 'RoomChooserModal__StyledItem'
	})(['display:none;', ';'], _theme.media.greaterThan('large')(_templateObject8));
	
	var RaffleConfirmationHeading = (0, _styledComponents2.default)(_Heading2.default).withConfig({
	  displayName: 'RoomChooserModal__RaffleConfirmationHeading'
	})(['color:', ';'], _theme.theme.color.limeGreen);
	
	var RoomChooserModal = function (_Component) {
	  _inherits(RoomChooserModal, _Component);
	
	  function RoomChooserModal(props) {
	    _classCallCheck(this, RoomChooserModal);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  RoomChooserModal.prototype.render = function render() {
	    var _props = this.props,
	        modalIsActive = _props.modalIsActive,
	        selectedRoom = _props.selectedRoom,
	        hasEnteredRaffle = _props.hasEnteredRaffle,
	        clearedQuizRoomIds = _props.clearedQuizRoomIds;
	
	    selectedRoom = selectedRoom.split('-').join(' ');
	
	    var showRaffleConfirmation = hasEnteredRaffle && clearedQuizRoomIds.length === 3;
	
	    return _react2.default.createElement(
	      Container,
	      { isOpen: modalIsActive },
	      _react2.default.createElement(
	        Modal,
	        null,
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            Flex,
	            null,
	            _react2.default.createElement(
	              StyledItem,
	              { width: 23, left: -14, bottom: 9 },
	              _react2.default.createElement(_ItemImage2.default, { src: _characterKeoniShaka3x2.default })
	            ),
	            _react2.default.createElement(
	              Copy,
	              null,
	              showRaffleConfirmation && _react2.default.createElement(
	                RaffleConfirmationHeading,
	                { level: 3, large: true },
	                'Thanks for entering!'
	              ),
	              _react2.default.createElement(
	                _Heading2.default,
	                { textAlign: 'left', level: 2, last: true },
	                'Select another room to find out more ways to save money'
	              )
	            ),
	            _react2.default.createElement(
	              MobileCopy,
	              null,
	              showRaffleConfirmation && _react2.default.createElement(
	                RaffleConfirmationHeading,
	                { level: 3, large: true },
	                'Thanks for entering!'
	              ),
	              _react2.default.createElement(
	                _Heading2.default,
	                { textAlign: 'center', level: 2 },
	                'Select another room to find out more ways to save money'
	              )
	            ),
	            _react2.default.createElement(
	              TilesWrapper,
	              null,
	              _react2.default.createElement(
	                Tiles,
	                null,
	                _react2.default.createElement(_LevelChooser.MobileTilesGroup, {
	                  selectedRoom: selectedRoom,
	                  context: 'modal'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(_PlayButton2.default, { context: 'modal' })
	        )
	      ),
	      _react2.default.createElement(TipBackground, { block: true })
	    );
	  };
	
	  return RoomChooserModal;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    modalIsActive: state.gameProgress.modalIsActive,
	    selectedRoom: state.gameProgress.selectedRoom,
	    hasEnteredRaffle: state.quizzes.hasEnteredRaffle,
	    clearedQuizRoomIds: state.quizzes.clearedQuizRoomIds
	  };
	};
	
	var RoomChooserModalConnected = (0, _reactRedux.connect)(mapStateToProps, null)(RoomChooserModal);
	exports.default = RoomChooserModalConnected;
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    height: 100%;\n  '], ['\n    height: 100%;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: 195px;\n  '], ['\n    width: 195px;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _redux = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(9);
	
	var _theme = __webpack_require__(4);
	
	var _gameProgress = __webpack_require__(12);
	
	var _checked = __webpack_require__(60);
	
	var _checked2 = _interopRequireDefault(_checked);
	
	var _tileOverlay = __webpack_require__(61);
	
	var _tileOverlay2 = _interopRequireDefault(_tileOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var RoomImageContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomOptionTile__RoomImageContainer'
	})(['cursor:pointer;position:relative;margin:0 3px;width:max(103px,min(12vw,120px));&:first-child{margin-left:0;}&:last-child{margin-right:0;}', ';'], _theme.media.greaterThan('medium')(_templateObject));
	
	var MobileRoomSelectContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'RoomOptionTile__MobileRoomSelectContainer'
	})(['width:230px;cursor:pointer;position:relative;margin:0 2px;overflow:hidden;&:first-child{margin-left:0;}&:last-child{margin-right:0;}', ''], _theme.media.greaterThan('medium')(_templateObject2));
	var StyledImage = _styledComponents2.default.img.withConfig({
	  displayName: 'RoomOptionTile__StyledImage'
	})(['position:relative;height:', ';max-width:100%;'], function (p) {
	  return p.viewport === 'desktop' ? '100%' : 'auto';
	});
	
	var Checked = _styledComponents2.default.img.withConfig({
	  displayName: 'RoomOptionTile__Checked'
	})(['margin:auto;position:absolute;top:0;left:0;bottom:0;right:0;width:50%;z-index:2;']);
	
	var OverlayImage = _styledComponents2.default.img.withConfig({
	  displayName: 'RoomOptionTile__OverlayImage'
	})(['position:absolute;top:0;left:0;width:100%;opacity:', ';transition:opacity 250ms ease-in-out;z-index:5;&:hover{opacity:0;}', ';'], function (p) {
	  return p.selected ? '0' : '0.4';
	}, _theme.media.greaterThan('medium')(_templateObject));
	
	var RoomOptionTile = function (_Component) {
	  _inherits(RoomOptionTile, _Component);
	
	  function RoomOptionTile(props) {
	    _classCallCheck(this, RoomOptionTile);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  RoomOptionTile.prototype.alreadyCleared = function alreadyCleared() {
	    var _props = this.props,
	        roomsCleared = _props.roomsCleared,
	        roomId = _props.roomId,
	        gameFinished = _props.gameFinished;
	
	
	    if (roomsCleared.includes(roomId) && !gameFinished) {
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  RoomOptionTile.prototype.handleClick = function handleClick() {
	    var _props2 = this.props,
	        roomId = _props2.roomId,
	        url = _props2.url;
	    var _props3 = this.props,
	        setSelectedRoom = _props3.setSelectedRoom,
	        setStartButtonUrl = _props3.setStartButtonUrl;
	
	    setSelectedRoom(roomId);
	    setStartButtonUrl(url);
	  };
	
	  RoomOptionTile.prototype.render = function render() {
	    if (this.props.viewport === 'desktop') {
	      return _react2.default.createElement(
	        RoomImageContainer,
	        { onClick: this.handleClick },
	        _react2.default.createElement(StyledImage, {
	          selected: this.props.selectedRoom === this.props.roomId,
	          src: this.props.img,
	          viewport: this.props.viewport
	        }),
	        _react2.default.createElement(OverlayImage, {
	          selected: this.props.selectedRoom === this.props.roomId,
	          src: _tileOverlay2.default,
	          viewport: this.props.viewport
	        }),
	        this.alreadyCleared() && _react2.default.createElement(Checked, { src: _checked2.default })
	      );
	    } else {
	      return _react2.default.createElement(
	        MobileRoomSelectContainer,
	        { onClick: this.handleClick },
	        _react2.default.createElement(StyledImage, {
	          selected: this.props.selectedRoom === this.props.roomId,
	          src: this.props.img,
	          viewport: this.props.viewport
	        }),
	        _react2.default.createElement(OverlayImage, {
	          selected: this.props.selectedRoom === this.props.roomId,
	          src: _tileOverlay2.default,
	          viewport: this.props.viewport
	        }),
	        this.alreadyCleared() && _react2.default.createElement(Checked, { src: _checked2.default })
	      );
	    }
	  };
	
	  return RoomOptionTile;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    selectedRoom: state.gameProgress.selectedRoom,
	    roomsCleared: state.gameProgress.roomsCleared,
	    gameFinished: state.gameProgress.gameFinished
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ setSelectedRoom: _gameProgress.setSelectedRoom, setStartButtonUrl: _gameProgress.setStartButtonUrl }, dispatch);
	};
	
	var RoomOptionTileConnected = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoomOptionTile);
	exports.default = RoomOptionTileConnected;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(120);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(4);
	
	var _AudioProvider = __webpack_require__(48);
	
	var _AudioProvider2 = _interopRequireDefault(_AudioProvider);
	
	var _Container = __webpack_require__(64);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _RoomChooserModal = __webpack_require__(97);
	
	var _RoomChooserModal2 = _interopRequireDefault(_RoomChooserModal);
	
	var _xylophone_affirm = __webpack_require__(127);
	
	var _xylophone_affirm2 = _interopRequireDefault(_xylophone_affirm);
	
	var _toilet = __webpack_require__(126);
	
	var _toilet2 = _interopRequireDefault(_toilet);
	
	var _QuizModal = __webpack_require__(96);
	
	var _QuizModal2 = _interopRequireDefault(_QuizModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import Footer from '../components/Footer'
	
	
	(0, _styledComponents.injectGlobal)(_templateObject, _theme.globalStyle);
	
	// const FooterPositioner = styled.div`
	//   bottom: 0;
	//   left: 0;
	//   position: fixed;
	//   right: 0;
	//   z-index: 1;
	// `
	
	var audioFiles = {
	  xyl1: _xylophone_affirm2.default,
	  toilet: _toilet2.default
	};
	
	var DebugOutlines = _styledComponents2.default.div.withConfig({
	  displayName: 'layouts__DebugOutlines'
	})(['*{outline:1px solid gold;}']);
	
	var MainLayout = function (_Component) {
	  _inherits(MainLayout, _Component);
	
	  function MainLayout() {
	    _classCallCheck(this, MainLayout);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  MainLayout.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    var ContainerComp = this.constructor.Container;
	
	    return _react2.default.createElement(
	      _AudioProvider2.default,
	      { sources: audioFiles },
	      _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _theme.theme },
	        _react2.default.createElement(
	          ContainerComp,
	          null,
	          _react2.default.createElement(_reactHelmet2.default, {
	            titleTemplate: '%s | Home Energy Tips',
	            defaultTitle: 'Home Energy Tips'
	          }),
	          children(),
	          _react2.default.createElement(_RoomChooserModal2.default, null),
	          _react2.default.createElement(_QuizModal2.default, null)
	        )
	      )
	    );
	  };
	
	  return MainLayout;
	}(_react.Component);
	
	MainLayout.propTypes = {
	  children: _propTypes2.default.func
	};
	MainLayout.Container = _Container2.default;
	exports.default = MainLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding-top: calc(', ' + ', ');\n  '], ['\n    padding-top: calc(', ' + ', ');\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(64);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(65);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _index = __webpack_require__(100);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledContainer = (0, _styledComponents2.default)(_Container2.default).withConfig({
	  displayName: 'room-green__StyledContainer'
	})(['background:linear-gradient(215deg,#059ca6,#81b678,#ebd38b);height:100%;overflow:hidden;padding-top:calc(', ' + ', ');z-index:0;', ';'], function (p) {
	  return p.theme.spacing(3.25);
	}, function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject, function (p) {
	  return p.theme.spacing(4);
	}, function (p) {
	  return p.theme.spacing(3);
	}));
	
	var StyledFooter = (0, _styledComponents2.default)(_Footer2.default).withConfig({
	  displayName: 'room-green__StyledFooter'
	})(['background:linear-gradient(to right,#3b8e64,#103027);']);
	
	var RoomGreenLayout = function (_MainLayout) {
	  _inherits(RoomGreenLayout, _MainLayout);
	
	  function RoomGreenLayout() {
	    _classCallCheck(this, RoomGreenLayout);
	
	    return _possibleConstructorReturn(this, _MainLayout.apply(this, arguments));
	  }
	
	  return RoomGreenLayout;
	}(_index2.default);
	
	RoomGreenLayout.Container = StyledContainer;
	RoomGreenLayout.Footer = StyledFooter;
	exports.default = RoomGreenLayout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-room-green-js-4cffc677912b58adf83b.js